export const AUTOMATION_IDS = {
  CTA: 'corvid-dev-mode-panel-cta',
  LEARN_MORE: 'corvid-dev-mode-panel-learn-more',
};

export const HELP_ARTICLE_IDS = {
  LEARN_MORE_CORVID: '72065e78-95f6-4af5-9434-07209f9ed0a6',
};
